export default __webpack_public_path__ + "static/test5-148da4fb955aacabf0d09555e8de7a28.jpeg";